import React from 'react';
import styled from 'styled-components';
import * as BuilderInfoUI from '../../BuilderInfoUI';
import { isNotNil } from '../../../../utils/types';
import { getCharacterByIncrementedIndex } from '../../../../utils/character';
import {
  ICohortRefFieldsFragment,
  IMeasureFieldsFragment,
} from '../../../../utils/apollo/graphqlSchema';
import { borderedContent } from '../../../../styles/shareableStyles';
import BuilderInfoLabelList from '../../components/BuilderInfoLabelList';
import { SvgIcon } from '../../../Icon';
import BadgeRound from '../../../BadgeRound';

interface IProps {
  measure: IMeasureFieldsFragment;
  cohorts: ICohortRefFieldsFragment[];
  rowIndex?: number;
}

const Container = styled(BuilderInfoUI.BorderedSectionHeader)`
  ${borderedContent};
`;

export default ({ measure, cohorts, rowIndex }: IProps) => {
  const { version } = measure;

  const measureLabel = isNotNil(rowIndex)
    ? getCharacterByIncrementedIndex('A', rowIndex)
    : undefined;

  return (
    <Container>
      {measureLabel && <BadgeRound size="small">{measureLabel}</BadgeRound>}
      {version?.name && <BuilderInfoLabelList items={[version.name]} />}
      {cohorts?.length > 0 && (
        <SvgIcon name="formula-cohort" width={14} height={14} isActive />
      )}
    </Container>
  );
};
